// removed by extract-text-webpack-plugin
module.exports = {"logo":"logo"};


//////////////////
// WEBPACK FOOTER
// ./src/common/component/logo/logo.style.sass
// module id = 5DQs
// module chunks = 3